var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.41675 8.71053C4.41675 12.4778 8.58647 16.5942 10.742 18.4706C11.4712 19.1053 12.5289 19.1053 13.2581 18.4706C15.4137 16.5942 19.5834 12.4778 19.5834 8.71053C19.5834 4.50175 16.1883 1.08984 12.0001 1.08984C7.81193 1.08984 4.41675 4.50175 4.41675 8.71053Z",
    stroke: "#DB4B41",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1663 8.9069C14.1663 10.1035 13.1963 11.0736 11.9997 11.0736V11.0736C10.8031 11.0736 9.83301 10.1035 9.83301 8.9069V8.9069C9.83301 7.71028 10.8031 6.74023 11.9997 6.74023V6.74023C13.1963 6.74023 14.1663 7.71028 14.1663 8.9069V8.9069Z",
    stroke: "#DB4B41",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50008 19.0723C2.86878 19.6652 1.16675 20.6092 1.16675 21.6725C1.16675 23.4673 6.01699 24.9225 12.0001 24.9225C17.9831 24.9225 22.8334 23.4673 22.8334 21.6725C22.8334 20.6092 21.1314 19.6652 18.5001 19.0723",
    stroke: "#DB4B41",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.57f86495d903245fb97cd4fb72431579.svg";
export { ForwardRef as ReactComponent };